import { useRef } from "react";
import { useBlockLayout, useTable } from "react-table";
import ScrollShadowProvider from "src/components/ScrollShadowProvider";

interface Props {
  data?: Array<any>;
  columns: Array<any>;
  [key: string]: any;
}

const CustomFieldTable = ({ data, columns, ...props }: Props) => {
  const { getTableProps, getTableBodyProps, headerGroups, prepareRow, rows } = useTable(
    {
      columns: columns,
      data: data ?? [],
      ...props,
    },
    useBlockLayout,
  );

  // 컬럼 합계가 컨테이너 폭을 넘어서므로 base-table.sticky(overflow:auto)에서 가로 스크롤 + 좌우 음영 처리
  const tableRef = useRef<HTMLDivElement>(null);

  return (
    <section className="inner-tab-table-closed-period">
      <ScrollShadowProvider tableRef={tableRef}>
        <div {...getTableProps()} className="base-table sticky" ref={tableRef}>
          <div className="header">
            {headerGroups.map((headerGroup) => (
              <div {...headerGroup.getHeaderGroupProps()} className="base-table__tr">
                {headerGroup.headers.map((header) => {
                  return (
                    <div {...header.getHeaderProps()} className="base-table__th flex-center-start">
                      {header.render("Header")}
                    </div>
                  );
                })}
              </div>
            ))}
          </div>
          <div {...getTableBodyProps()} className="body">
            {rows.map((row) => {
              prepareRow(row);
              return (
                <div {...row.getRowProps()} className={`base-table__tr`}>
                  {row.cells.map((cell) => {
                    const isMultiLine = (row.original as any)?.times?.length > 1;
                    return (
                      <div {...cell.getCellProps()} className={`base-table__td flex-row ${isMultiLine && "multi-line"}`}>
                        {cell.render("Cell")}
                      </div>
                    );
                  })}
                </div>
              );
            })}
          </div>

          {rows.length === 0 && (
            <div className="base-table__tr table-cursor-unset">
              <div className="base-table__td w-100 text-center">
                <div className="w-100">
                  <span>데이터가 없습니다.</span>
                </div>
              </div>
            </div>
          )}
        </div>
      </ScrollShadowProvider>
    </section>
  );
};

export default CustomFieldTable;
